import type { FacetFilters } from '@/types/catalog'
import * as apiBff from './bff'
import { createProductQueryParams } from './query-params'

export async function getProductsHeader<T>({
  season,
  universeId,
  departmentId,
  families,
  subdepartments,
  filters = {},
  productCode,
}: {
  season: string
  universeId: number
  departmentId: number
  families: number[]
  subdepartments?: number[]
  filters: FacetFilters
  productCode: string | null
}): Promise<T> {
  const params = createProductQueryParams({
    families,
    subdepartments,
    filters,
    productCode,
  })

  return apiBff.callBFF<T>(
    'GET',
    `season/${season}/universes/${universeId}/departments/${departmentId}/header?${params.toString()}`,
  )
}
